import type { CopyShape } from "@tami/core/intl";

import type { SIDEBAR_COPY_PT_BR } from "../sidebar.copy";

export const SIDEBAR_COPY_ES_ES: CopyShape<typeof SIDEBAR_COPY_PT_BR> = {
  toggle: "Mostrar u ocultar la barra lateral",
  mobileTitle: "Menú",
  mobileDescription: "Navegación del móvil",
};
